import { SHOW_COSTING } from "@/lib/features";
import { fmtQty } from "@/lib/constants";
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(); } catch { return "—"; } };

export function buildPoHtml(po, plantName = "H. K. INDUSTRIES (D-54)") {
  const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const priced = SHOW_COSTING && (po.items || []).some((i) => Number(i.unit_price || 0) > 0);
  const grand = (po.items || []).reduce((s, i) => s + Number(i.ordered_qty || 0) * Number(i.unit_price || 0), 0);
  const rows = (po.items || [])
    .map((i) => `<tr><td class="mono">${esc(i.sku)}</td><td>${esc(i.name)}</td>
      <td class="num">${fmtQty(i.ordered_qty, i.unit)} ${esc(i.unit)}</td>
      <td class="num">${fmtQty(i.received_qty, i.unit)} ${esc(i.unit)}</td>
      ${priced ? `<td class="num">${inr(i.unit_price)}</td><td class="num">${inr(Number(i.ordered_qty || 0) * Number(i.unit_price || 0))}</td>` : ""}</tr>`)
    .join("");
  const totalRow = priced
    ? `<tr><td colspan="5" class="num" style="border-top:2px solid #0f172a;font-weight:700;">Total</td><td class="num" style="border-top:2px solid #0f172a;font-weight:700;">${inr(grand)}</td></tr>`
    : "";
  return `<!DOCTYPE html><html><head><title>${esc(po.po_number)}</title><style>
    body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;margin:32px;}
    h1{font-size:20px;margin:0;} .muted{color:#64748b;font-size:12px;}
    .box{border:1px solid #e2e8f0;border-radius:8px;padding:14px 18px;margin:16px 0;font-size:13px;}
    table{width:100%;border-collapse:collapse;font-size:12px;margin-top:8px;}
    th{text-align:left;text-transform:uppercase;font-size:10px;color:#64748b;border-bottom:2px solid #0f172a;padding:6px 8px;}
    td{border-bottom:1px solid #e2e8f0;padding:8px;} td.num,th.num{text-align:right;} td.mono{font-family:monospace;}
    .status{display:inline-block;padding:2px 10px;border-radius:999px;font-size:11px;font-weight:700;background:#eff6ff;color:#1d4ed8;}
  </style></head><body>
    <h1>Purchase Order ${esc(po.po_number)}</h1>
    <p class="muted">${esc(plantName)} · raised ${fmt(po.created_at)}</p>
    <div class="box">
      <strong>Supplier:</strong> ${esc(po.supplier) || "—"}<br/>
      <strong>Status:</strong> <span class="status">${esc(po.status)}</span> &nbsp;
      <strong>Expected:</strong> ${fmt(po.expected_date)} &nbsp;
      <strong>Lead time:</strong> ${esc(po.lead_time_days)} days
    </div>
    <table><thead><tr><th>SKU</th><th>Material</th><th class="num">Ordered</th><th class="num">Received</th>${priced ? `<th class="num">Unit Price</th><th class="num">Amount</th>` : ""}</tr></thead>
      <tbody>${rows}${totalRow}</tbody></table>
    <p class="muted" style="margin-top:28px;">H. K. INDUSTRIES · Production Planning</p>
  </body></html>`;
}

export function printPo(po, plantName) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  frame.srcdoc = buildPoHtml(po, plantName);
  frame.onload = () => {
    try { frame.contentWindow.focus(); frame.contentWindow.print(); }
    finally { setTimeout(() => frame.remove(), 1000); }
  };
  document.body.appendChild(frame);
}
